import axios from 'axios';
import { useEffect, useState } from 'react';
import makeAnimated from 'react-select/animated';
import AsyncSelect from 'react-select/async';

const SearchFactory = ({ setFactories, modalInfo }) => {
    const [query, setQuery] = useState('')
    const [selectedOption, setSelectedOption] = useState('')
    
    //get animated components wrapper
    const animatedComponents = makeAnimated();
    
    const { REACT_APP_API_BACKEND_URL } = process.env;

    // call when edit phase
    useEffect(() => {
        if (modalInfo) {
            setSelectedOption(   modalInfo.factories)
            setFactories(modalInfo.factories);
        }
    }, [modalInfo, setFactories]);

    const loadOptions = async ( ) => {
        // You must return this otherwise react-select won't know when the promise resolves! 
        const url = REACT_APP_API_BACKEND_URL + '/api/grievance/getfactoryAndCategorylist'
        
        const res = await axios.get(url)
        const data = await res.data;
        console.log(data);
        const results = data.grievanceFactoryList;
        console.log(results);

        if (results === 'No result found.') {
            return [];
        } else {
            return results;
        }
    };

    const handleChange = (selectedOption) => {
        console.log("selected Option:", selectedOption);
        setSelectedOption(selectedOption);

        setFactories(selectedOption);
    };


    return (
        <AsyncSelect
            placeholder={"Search by factory..."}
            defaultOptions
            cacheOptions
            isMulti
            components={animatedComponents}
            getOptionLabel = {(e)=> e.factory}
            getOptionValue = {(e)=> e.id}
            loadOptions={loadOptions}
            value={selectedOption}
            onInputChange={(value) => setQuery(value)}
            onChange={handleChange}
            isClearable
            // styles={customStyles} 
        />
    );
};

export default SearchFactory;
